/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoTimePicker implements angular.IDirective {
        businessInfoService: Meevo.Components.Common.IBusinessInfoDataService;
        standard = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        military = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        mins = [];
        allMins = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
            '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']
        //meridians = ['AM', 'PM'];     /*  It is been set based on appSettings */
        require = 'ngModel';
        scope = {
            ngModel: '=ngModel',
            //showAmPm: '=?',           /*  It is been set based on appSettings */
            interval: '=?',
            contentKey: '@',
            disabled: '=ngDisabled',
            changed: '&ngChange',
            tabIndex: '=tabIndex',
            rangeValidation: '=?',
            rangeStart: '=?',
            rangeEnd: '=?',
            allMin: '=?',
            required: "=ngRequired", // Added this late so needed to default to true below so didn't have to modify all existing consumers that assume its always true
            honorAppointmentBookIncrement: "=?",
            startsWith: '@?',
            amPmIdentifier: '=?'
        };

        templateUrl = 'app/components/controls/timePickerTemplate.html';

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            if (angular.isUndefined(scope.honorAppointmentBookIncrement)) {
                scope.honorAppointmentBookIncrement = false;
            }
            var businessInfoService = this.businessInfoService;
            scope.appointmentBookIncrementNumber = businessInfoService.getAppointmentBookIncrementInMinutes(this.$rootScope.appointmentBookSettings.appointmentBookPrecisionIncrement);
            this.mins = [];
            for (var i = 0; i < 60; i += scope.honorAppointmentBookIncrement ? 5 : 15) {
                if(i === 0 && scope.startsWith) {
                    const n = parseInt(scope.startsWith);
                    this.mins.push(n < 10 ? "0" + n : n + "");
                    continue;
                }

                this.mins.push(i < 10 ? "0" + i :i + "");
            }
            scope.mins = scope.allMin ? this.allMins : this.mins;
            scope.meridians = this.appSettings.APP_AMPMS;
            scope.requiredLocal = scope.required == undefined ? true : scope.required;

            if (scope.rangeValidation) {
                ngModel.$validators['invalidRange'] = validateTimeRange;
            }

            /**
             * if time value should be in some range - please use
             * (1) rangeValidation object with messages
             * (2) rangeStart param time string
             * (3) rangeEnd param - time string
             * @example rangeValidation = {
             *       soonerMessage: 'Should start not earlier than business starts working',
             *       laterMessage: 'Should end not later than Walk-In end hours'
             *   }
             * @example rangeStart = '1900-01-01T07:00:00.0000000'
             * @example rangeEnd = '1900-01-01T21:00:00.0000000'
             * @param {Date} modelValue
             * @returns {boolean} valid
             * */
            function validateTimeRange(modelValue: Date) {
                let validStart = false,
                    validEnd = false;

                if (scope.rangeStart) {
                    validStart = modelValue >= scope.rangeStart;
                    scope.timePickerForm.timeValue.$error.sooner = !validStart;
                }
                if (scope.rangeEnd) {
                    validEnd = modelValue <= scope.rangeEnd;
                    scope.timePickerForm.timeValue.$error.later = !validEnd;
                }

                return validStart && validEnd;
            }

            scope.showAmPm = Meevo.Model.TimeFormatEnum.TimeFormat12 === this.appSettings.APP_TIME_FORMAT
            scope.selectedMeridian = scope.selectedMeridian || this.appSettings.APP_AMPMS[0];

            ngModel.$render = () => {

                if (scope.showAmPm) {
                    scope.hours = this.standard;
                } else {
                    scope.hours = this.military;
                }

                if (angular.isDate(ngModel.$viewValue)) {
                    let hour = moment(ngModel.$viewValue).hours(),
                        minute;

                    if (scope.showAmPm) {
                        /** Always get meridian based on locale en-US*/
                        const meridian = moment(ngModel.$viewValue).locale('en').format('a').toLocaleLowerCase();
                        if (meridian === 'am') {
                            scope.selectedMeridian = this.appSettings.APP_AMPMS[0]
                        } else {
                            scope.selectedMeridian = this.appSettings.APP_AMPMS[1]
                        }

                        hour = Number(moment(ngModel.$viewValue).format('h'));
                    }

                    if (moment(ngModel.$viewValue).minutes() < 10) {
                        minute = "0" + moment(ngModel.$viewValue).minutes().toString();
                    } else {
                        minute = moment(ngModel.$viewValue).minutes().toString();
                    }
                    scope.selectedHour = hour == 0 ? hour + "" : hour ;
                    scope.selectedMinute = minute;
                } else {
                    scope.selectedHour = null;
                    scope.selectedMinute = null;
                    scope.selectedMeridian = null;
                }
            };

            scope.updateModelFromFields = () => {
                let d: Date;
                let adjustedHour: number;

                scope.selectedHour = scope.selectedHour || '0';
                scope.selectedMinute = scope.selectedMinute || '00';

                if (angular.isDate(ngModel.$viewValue)) {
                    d = new Date(ngModel.$viewValue);
                } else {
                    d = moment().startOf('day').toDate();
                }

                d.setMinutes(scope.selectedMinute);
                adjustedHour = +scope.selectedHour;

                if (scope.showAmPm) {
                    if (scope.selectedMeridian === this.appSettings.APP_AMPMS[0]) {
                        if (adjustedHour === 12) {
                            adjustedHour = 0;
                        }
                    } else if (scope.selectedMeridian === this.appSettings.APP_AMPMS[1]) {
                        if (adjustedHour < 12) {
                            adjustedHour += 12;
                        }
                    }
                }

                d.setHours(adjustedHour);
                ngModel.$setViewValue(d);

                if (typeof scope.changed === 'function') {
                    scope.changed();
                }
            }
        };

        constructor(private appSettings: Meevo.Components.Common.IAppSettings,
            private $rootScope, businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService) {
            this.businessInfoService = businessInfoDataService;
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (appSettings: Meevo.Components.Common.IAppSettings, $rootScope: any, businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService) => {
                return new MeevoTimePicker(appSettings, $rootScope, businessInfoDataService);
            };
            directive.$inject = [
                "meevo.AppSettings",
                "$rootScope",
                "meevo.components.common.BusinessInfoDataService"
            ];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoTimePicker', MeevoTimePicker.factory());
}
